import {Component, HostListener, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../../services/api.service';
import * as _ from 'lodash';
import {HttpParams} from '@angular/common/http';
import {trigger, state, style, transition, animate} from '@angular/animations';
import * as moment from 'moment';
import {FileHandle} from './drag-drop.directive';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-link-code',
  templateUrl: './link-code.component.html',
  styleUrls: ['./link-code.component.scss'],
  animations: [
    trigger('rowExpansionTrigger', [
      state('void', style({
        transform: 'translateX(-10%)',
        opacity: 0
      })),
      state('active', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class LinkCodeComponent implements OnInit {
  modal: NgbModalRef;
  cust_list = [];
  selectedAddr: any;
  delivery_c: any;
  delivery_n: any;
  delivery_add: any;
  delivery_add_province: any;
  delivery_add_district: any;
  delivery_add_subdistrict: any;
  delivery_add_postalcode: any;
  delivery_email = [];
  delivery_cc = [];
  delivery_tel = [];
  loading = false;
  loading_main = false;
  searchcustcode: any;
  searchaddrcode: any;
  newemailVal: string;
  totalItems = 0;
  newtelVal: any;
  modalData: any;
  currentPage = 1;
  itemsPerPage = 40;
  showlist = [];
  addrlist_of_selected_cust = [];
  addrlist_without_cust = [];
  newcustname: any;
  newcustcode: any;
  newcontactname: any;
  rowGroupMetadata: any;
  Delivery = [];
  data = [];
  keep_email = [];
  keep_cc = [];
  keep_tel = [];
  loadinput = [];
  delivery_data: any;
  delivery_email_update = [];
  delivery_email_updatedata = [];
  delivery_cc_update = [];
  delivery_cc_updatedata = [];
  delivery_tel_update = [];
  delivery_tel_updatedata = [];
  sortBy: string;
  sortMode: string;
  searchdelivery: string;
  deleteDelivery: any;
  deleteCustomer: any;
  errorMess: any;
  tempdataload_Delivery: any;
  tempindex_Delivery: any;
  keepexcel: any;
  errorMessage: any;
  updateMessage: any;
  files: FileHandle[] = [];


  constructor(private modalService: NgbModal,
              private apiService: ApiService,
              private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.selectedAddr = null;
    this.loadCustomerList();
    this.loadInput();
  }

  filesDropped(files: FileHandle[]): void {
    // this.files = files;
    this.keepexcel = [];
    this.keepexcel.push(files[0].file);
  }
  loadCustomerList(page?) {
    this.selectedAddr = null;
    this.cust_list = [];
    this.loading_main = true;
    let params = new HttpParams();

    if (this.searchdelivery) {
      params = params.append('search', this.searchdelivery);
    }
    if (this.searchcustcode) {
      params = params.append('id', this.searchcustcode);
    }
    if (this.searchcustcode == null && this.searchdelivery == null) {
      params = params.append('page', this.currentPage.toString());
      params = params.append('page_size', this.itemsPerPage.toString());
    }


    this.apiService.getCustomerList(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.totalItems = result.count;
        this.cust_list.push({
          label: obj.c_code,
          name: obj.c_name,
          value: obj.id,
          contact_name: obj.c_contact_name,
          delivery: [this.data],
          keepdelivery: obj.delivery_codes
        });
      });
      this.loading_main = false;
      this.updateRowGroupMetaData();
    });
  }

  loadInput() {
    this.loadinput = [];
    this.loading_main = true;
    let params = new HttpParams();
    params = params.append('none_pagination', 'true');
    this.apiService.getCustomerList(params).subscribe((result) => {
      _.forEach(result, (obj) => {
        this.loadinput.push({
          label: obj.c_code,
          name: obj.c_name,
          value: obj.id,
          contact_name: obj.c_contact_name,
          delivery: [this.data]
        });
        this.loading_main = false;
      });
      this.updateRowGroupMetaData();
    });
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.cust_list) {
      for (let i = 0; i < this.cust_list.length; i++) {
        const rowData = this.cust_list[i];
        const value = rowData.value;
        if (i == 0) {
          this.rowGroupMetadata[value] = {index: 0, size: 1};
        } else {
          const previousRowData = this.cust_list[i - 1];
          const previousRowGroup = previousRowData.value;
          if (value === previousRowGroup)
            this.rowGroupMetadata[value].size++;
          else
            this.rowGroupMetadata[value] = {index: i, size: 1};
        }
      }
    }
  }

  onSort() {
    this.updateRowGroupMetaData();
  }

  editcode(event, popup, res) {
    this.modalData = res;
    this.load_addrlist_selected_cust();
    this.get_addrlist_without_cust();
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false});
  }

  editdelivery(event, popup, res) {
    this.delivery_data = res;
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false});
    this.delivery_c = res.name;
    this.delivery_n = res.c_name;
    this.delivery_add = res.address;
    this.delivery_add_province = res.province;
    this.delivery_add_district = res.district;
    this.delivery_add_subdistrict = res.subdistrict;
    this.delivery_add_postalcode = res.postalcode;
    this.delivery_email = res.mail;
    this.delivery_email_update = this.delivery_email.map(obj => {
      return {email: obj};
    });
    this.delivery_cc = res.cc;
    this.delivery_cc_update = this.delivery_cc.map(obj => {
      return {cc: obj};
    });
    this.delivery_tel = res.tel;
    this.delivery_tel_update = this.delivery_tel.map(obj => {
      return {tel: obj};
    });
  }

  AddfelidEmail() {
    this.keep_email.push({email: ''});
  }

  AddfelidCC() {
    this.keep_cc.push({cc: ''});
  }

  AddfelidTel() {
    this.keep_tel.push({tel: ''});
  }

  get_addrlist_without_cust() {
    this.delivery_c = null;
    this.delivery_n = null;
    this.delivery_add = null;
    this.delivery_email = null;
    this.delivery_tel = null;
    this.delivery_cc = null;
    this.delivery_add_district = null;
    this.delivery_add_postalcode = null;
    this.delivery_add_province = null;
    this.delivery_add_subdistrict = null;
    this.addrlist_without_cust = [];
    this.apiService.getDeliveryList().subscribe((result) => {
      _.forEach(result, (obj) => {
        if (obj.d_custcode === null) {
          this.addrlist_without_cust.push({
            label: obj.d_code,
            name: obj.d_name,
            address: obj.d_address,
            email: obj.d_email_list,
            cc: obj.d_cc_list,
            tel: obj.d_tel_list,
            value: obj.id
          });
        }
      });
    });
  }

  load_Delivery(event, data, rowIndex) {
    this.tempdataload_Delivery = data;
    this.tempindex_Delivery = rowIndex;
    let params = new HttpParams();
    params = params.append('d_custcode', data.value);
    if (this.searchdelivery) {
      params = params.append('search', this.searchdelivery);
    }
    const dcTemp = [];
    // this.data = data;
    this.apiService.getDeliveryList(params).subscribe((result) => {
      result = _.orderBy(result, ['d_code'], ['asc']);
      _.forEach(result, (obj) => {
        dcTemp.push({
          name: obj.d_code,
          id: obj.id,
          c_name: obj.d_name,
          custcode: obj.d_custcode,
          address: obj.d_address,
          subdistrict: obj.d_subdistrict,
          province: obj.d_province,
          district: obj.d_district,
          postalcode: obj.d_postalcode,
          mail: obj.d_email_list,
          cc: obj.d_cc_list,
          tel: obj.d_tel_list
        });
      });
      this.cust_list[rowIndex]['delivery'] = dcTemp;
    });
  }

  load_addrlist_selected_cust() {
    this.addrlist_of_selected_cust = [];
    const params = new HttpParams()
      .set('d_custcode', this.modalData.value);
    this.apiService.getDeliveryList(params).subscribe((result) => {
      _.forEach(result, (obj) => {
        this.addrlist_of_selected_cust.push({
          label: obj.d_code,
          name: obj.d_name,
          address: obj.d_address,
          province: obj.d_province,
          district: obj.d_district,
          subdistrict: obj.d_subdistrict,
          postalcode: obj.d_postalcode,
          email: obj.d_email_list,
          cc: obj.d_cc_list,
          tel: obj.d_tel_list,
          id: obj.id,
          value: obj.d_custcode
        });
      });
    });
  }

  revertBack() {
    this.delivery_email_update = [];
    this.delivery_cc_update = [];
    this.delivery_tel_update = [];
    this.delivery_tel = [];
    this.delivery_cc = [];
    this.delivery_email = [];
    this.selectedAddr = null;
    this.keep_email = [];
    this.keep_tel = [];
    this.keep_cc = [];
    this.modal.close();
    this.updateMessage = null;
    this.errorMessage = null;
  }

  cleardataEdit() {
    this.delivery_email_updatedata = [];
    this.delivery_cc_updatedata = [];
    this.delivery_tel_updatedata = [];
  }

  clearSearch() {
    this.delivery_email_updatedata = [];
    this.delivery_email_update = [];
    this.delivery_cc_updatedata = [];
    this.delivery_cc_update = [];
    this.delivery_tel_updatedata = [];
    this.delivery_tel_update = [];
    this.loadinput = [];
    this.searchcustcode = null;
    this.searchaddrcode = null;
    this.delivery_c = null;
    this.delivery_n = null;
    this.delivery_add = null;
    this.delivery_email = [];
    this.delivery_tel = [];
    this.delivery_cc = [];
    this.keep_email = [];
    this.keep_tel = [];
    this.keep_cc = [];
    this.cust_list = [];
    this.delivery_add_district = null;
    this.delivery_add_postalcode = null;
    this.delivery_add_province = null;
    this.delivery_add_subdistrict = null;
    this.modal = null;
    this.modalData = null;
    this.searchdelivery = null;
    this.loading_main = false;
    this.currentPage = 1;
    this.loadCustomerList();
    this.loadInput();

  }

  search() {

    this.loadCustomerList();
  }

  pageChanged() {
    // const page = new HttpParams().set('page', this.currentPage.toString());
    this.loadCustomerList(this.currentPage);
  }

  optionChanged() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadCustomerList();
    // TODO To fix
  }

  create_cust(event, newpopup) {
    this.newcustname = null;
    this.newcustcode = null;
    this.newcontactname = null;
    this.modal = this.modalService.open(newpopup, {backdrop: 'static', keyboard: false});
  }

  delete_customer(event, popup, res) {
    this.deleteCustomer = null;
    this.deleteCustomer = res;
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false});
  }

  confirm_deleteCus() {
    this.loading_main = true;
    this.apiService.deleteCust(this.deleteCustomer.value).subscribe(
      () => {
        this.loadCustomerList();
        this.loading_main = false;
        this.modal.close();
      },
      error => {
        this.errorMess = error;
        this.loading_main = false;
        console.log(error);
      }
    );
  }

  delete_delivery(event, popup, res) {
    this.deleteDelivery = null;
    this.deleteDelivery = res;
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false});
  }

  confirm_deleteDeli() {
    this.loading_main = true;
    this.apiService.deleteDeli(this.deleteDelivery.id).subscribe(
      () => {
        this.loadCustomerList();
        this.loading_main = false;
        this.modal.close();
      },
      error => {
        this.errorMess = error;
        this.loading_main = false;
        console.log(error);
      }
    );
  }

  delete_email_list(index, res) {
    this.delivery_email_update.splice(index, 1);
  }

  delete_cc_list(index, res) {
    this.delivery_cc_update.splice(index, 1);
  }

  delete_tel_list(index, res) {
    this.delivery_tel_update.splice(index, 1);
  }

  delete_felidEmail(index, res) {
    this.keep_email.splice(index, 1);
  }

  delete_felidCC(index, res) {
    this.keep_cc.splice(index, 1);
  }

  delete_felidTel(index, res) {
    this.keep_tel.splice(index, 1);
  }


  save_new_customer() {
    this.loading_main = true;
    const data = {
      'c_code': this.newcustcode,
      'c_name': this.newcustname,
      'c_contact_name': this.newcontactname
    };
    this.modal.close();
    this.apiService.postCreateCust(data).subscribe();
    setTimeout(() => {
      this.loadCustomerList();
      this.loading_main = false;
      this.showlist = this.cust_list;
    }, 2000);
  }

  add_cust_on_addrcode(res) {
    if (this.delivery_c == null) {
      return;
    }
    _.forEach(_.concat(this.delivery_email_update, this.keep_email), (obj) => {
      this.delivery_email_updatedata.push(obj.email);
    });
    _.forEach(_.concat(this.delivery_cc_update, this.keep_cc), (obj) => {
      this.delivery_cc_updatedata.push(obj.cc);
    });
    _.forEach(_.concat(this.delivery_tel_update, this.keep_tel), (obj) => {
      this.delivery_tel_updatedata.push(obj.tel);
    });
    this.loading = true;
    this.loading_main = true;
    const data = {
      'd_code': this.delivery_c,
      'd_name': this.delivery_n,
      'd_address': this.delivery_add,
      'd_province': this.delivery_add_province,
      'd_district': this.delivery_add_district,
      'd_subdistrict': this.delivery_add_subdistrict,
      'd_postalcode': this.delivery_add_postalcode,
      'd_email_list': this.delivery_email_updatedata,
      'd_cc_list': this.delivery_cc_updatedata,
      'd_tel_list': this.delivery_tel_updatedata,
      'd_custcode': res.value
    };
    this.apiService.postAddCustOnDelivery(data).subscribe();
    setTimeout(() => {
      this.load_addrlist_selected_cust();
      this.get_addrlist_without_cust();
      this.loading = false;
      this.modal.close();
      this.loading_main = false;
      this.clearSearch();
    }, 2000);
  }

  update_delivery(res) {
    _.forEach(_.concat(this.delivery_email_update, this.keep_email), (obj) => {
      this.delivery_email_updatedata.push(obj.email);
    });
    _.forEach(_.concat(this.delivery_cc_update, this.keep_cc), (obj) => {
      this.delivery_cc_updatedata.push(obj.cc);
    });
    _.forEach(_.concat(this.delivery_tel_update, this.keep_tel), (obj) => {
      this.delivery_tel_updatedata.push(obj.tel);
    });
    this.loading = true;
    // this.loading_main = true;
    const data = {
      'd_code': this.delivery_c,
      'd_name': this.delivery_n,
      'd_address': this.delivery_add,
      'd_province': this.delivery_add_province,
      'd_district': this.delivery_add_district,
      'd_subdistrict': this.delivery_add_subdistrict,
      'd_postalcode': this.delivery_add_postalcode,
      'd_email_list': this.delivery_email_updatedata,
      'd_cc_list': this.delivery_cc_updatedata,
      'd_tel_list': this.delivery_tel_updatedata,
      'd_custcode': res.custcode,
      'id': res.id
    };
    this.apiService.updategetDeliveryList(data).subscribe();
    setTimeout(() => {
      this.cleardataEdit();
      this.loading = false;
      let params = new HttpParams();
      params = params.append('d_custcode', this.tempdataload_Delivery.value);
      if (this.searchdelivery) {
        params = params.append('search', this.searchdelivery);
      }
      const dcTemp = [];
      // this.data = data;
      this.apiService.getDeliveryList(params).subscribe((result) => {
        result = _.orderBy(result, ['d_code'], ['asc']);
        _.forEach(result, (obj) => {
          dcTemp.push({
            name: obj.d_code,
            id: obj.id,
            c_name: obj.d_name,
            custcode: obj.d_custcode,
            address: obj.d_address,
            subdistrict: obj.d_subdistrict,
            province: obj.d_province,
            district: obj.d_district,
            postalcode: obj.d_postalcode,
            mail: obj.d_email_list,
            cc: obj.d_cc_list,
            tel: obj.d_tel_list
          });
        });
        this.cust_list[this.tempindex_Delivery]['delivery'] = dcTemp;
      });
      // this.loading_main = false;
      // this.modal.close();
      // this.clearSearch();
    }, 2000);
  }

  exportDownload() {
    this.apiService.getExportExcel().subscribe(obj => {
      console.log(obj);
      const filename = 'download_list_code' + '.xlsx';
      this.apiService.createDownloadFile(obj, filename);
    });
  }


  create_excel(event, newpopup) {
    this.keepexcel = [];
    this.modal = this.modalService.open(newpopup, {backdrop: 'static', keyboard: false});
  }

  saveImport() {
    // this.loading_main = true;
    this.loading = true;
    setTimeout(() => {
      const params = new FormData();
      for (let i = 0; i < this.keepexcel.length; i++) {
        params.append('file', this.keepexcel[i], this.keepexcel[i].name);
        // params.append('file[]', this.keepexcel[i], this.keepexcel[i].name); for many file
      }
      this.apiService.getImportExcel(params).subscribe(obj => {
        console.log(this.keepexcel);
        // alert(obj.message);
        this.updateMessage = obj.message;
        this.errorMessage = null;
      }, e => {
        this.errorMessage = e.error.message;
      });
      this.loading = false;
      this.loading_main = false;
      // this.modal.close();
      // this.clearSearch();
    }, 2000);

  }

  handleFiles(event) {
    if (event.target.files.length > 0) {
      this.keepexcel = [];
      // console.log(event.target.files[0].name);
      for (const file of event.target.files) {
        this.keepexcel.push(file);
      }
      console.log(this.keepexcel);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/link-code/link-code.component.ts